module.exports = __webpack_public_path__ + "img/ecpay_logo.87fee34d.png";